module.exports = __webpack_public_path__ + "static/media/roomsActive.3fdf7ce1.svg";